<template>
  <hel-module title="企业经营核心指标" :class="scope.clsPrefix"  v-loading="loading">
    <div v-if="error" class="indicator-error">
      <span class="indicator-error-text">数据加载失败</span>
      <button class="indicator-error-retry" @click="fetchBaseMetrics">
        <i class="el-icon-refresh"></i>
        <span>重新加载</span>
      </button>
    </div>
    <div v-else-if="!indicators.length" class="indicator-empty">
      <span class="indicator-empty-text">暂无指标数据</span>
    </div>
    <div v-else class="indicators-container">
      <div class="indicators-main">
        <div class="indicator-item" v-for="(item, index) in indicators" :key="index" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1">
        <div class="indicator-header">
          <span class="indicator-name">{{ item.name }}</span>
          <span :class="['indicator-trend', item.trendClass]">
            <span class="trend-value">环比 {{ item.trendValue }}</span>
          </span>
        </div>
        <div class="indicator-value">
          <span class="value-num">{{ item.value }}</span>
          <span class="value-unit">{{ item.unit }}</span>
        </div>
        <div class="indicator-mask" v-show="hoverIndex === index">
          <button class="smart-analysis-btn" @click.stop="handleSmartAnalysis(item)">智能分析</button>
        </div>
      </div>
      </div>

    </div>
  </hel-module>
</template>

<script>
import HelModule from '../../components/common/module/index.vue'
import axios from 'axios'
import { getToken } from '@/utils/auth'
export default {
  name: 'BusinessIndicators',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-business-indicators'
      },
      hoverIndex: -1,
      // 企业当月综合能耗指标（由 /kx/ceo/data 接口返回）
      indicators: []
    }
  },
  created() {
    this.fetchBaseMetrics()
  },
  mounted() {},
  methods: {
    handleSmartAnalysis(item) {
      this.$emit('smart-analysis', item)
    },
    // 环比涨跌着色：
    // 消耗类指标（用电/用水/天然气/压缩空气/碳排）下降=节能=绿色，上升=红色；
    // 产出类指标（光伏发电量）上升=绿色，下降=红色
    getTrendClass(name, momRate) {
      const rate = parseFloat(momRate)
      if (Number.isNaN(rate) || rate === 0) return 'trend-flat'
      const isConsumption = name !== '当月光伏发电量'
      const isUp = rate > 0
      const isGood = isConsumption ? !isUp : isUp
      return isGood ? 'trend-up' : 'trend-down'
    },
    // 数值展示：接口已是目标单位字符串，仅对纯数字加千分位（至多保留两位小数）
    formatNumber(value) {
      const num = Number(value)
      if (value === null || value === undefined || value === '' || Number.isNaN(num)) {
        return value
      }
      return num.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    async fetchBaseMetrics() {
      this.loading = true
      this.error = false
      try {
        const response = await axios.get('/energy-api/kx/ceo/data',
          {
            headers: {
              token: getToken()
            }
          }
        )
        const res = response.data || {}
        const list = (res.data && res.data.indicators) || []
        this.indicators = list.map((item) => ({
          name: item.name,
          value: this.formatNumber(item.currentValue),
          unit: item.unit || '',
          trendValue: item.momRate || '0%',
          trendClass: this.getTrendClass(item.name, item.momRate)
        }))
      } catch (error) {
        console.error('获取企业综合能耗指标失败:', error)
        this.error = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-business-indicators";
.indicators-main {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  margin-bottom: 8px;
}
.#{$class-prefix} {
  overflow: hidden;

  .indicator-error,
  .indicator-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 106px;
    gap: 8px;
  }

  .indicator-error-text,
  .indicator-empty-text {
    font-size: 13px;
    color: #94a3b8;
  }

  .indicator-error-text {
    color: #F44F4F;
  }

  .indicator-error-retry {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 14px;
    border: 1px solid #4a5ff3;
    border-radius: 4px;
    background: #fff;
    font-size: 12px;
    color: #4a5ff3;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #f0f2ff;
    }
  }

  .indicators-container {
    height: 106px;
    width: 100%;
    // overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: transparent;
  }
  .indicators-container:hover {
    scrollbar-width: thin;
    scrollbar-color: #b0b0b0 #e8e8e8;
  }
  .indicator-item {
    // flex: 0 0 auto;
    // width: 180px;
    // min-width: 180px;
    flex: 1;
    // width: calc(100% / 7);
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: #EFF2FC;
    // align-items: center;
    justify-content: space-between;
    padding: 16px;
    height: 106px;
    position: relative;
    // border-right: 1px solid #f0f0f0;
    // &:last-child {
    //   border-right: none;
    // }
    .indicator-header {
      display: flex;
      flex-direction: column;
      // align-items: center;
      // justify-content: center;
      // gap: 2px;
      margin-bottom: 8px;
    }
    .indicator-name {
      font-size: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
      margin-bottom: 4px;
    }
    .indicator-trend {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      &.trend-up {
        color: #73B950;
      }
      &.trend-down {
        color: #F44F4F;
      }
      &.trend-flat {
        color: #F4B13D;
      }
    }
    .trend-value {
      font-weight: 500;
    }
    .indicator-value {
      display: flex;
      align-items: baseline;
      gap: 8px;
    }
    .value-num {
      font-size: 24px;
      font-weight: 700;
      font-family: PingFangSC-Semibold;
      color: #333;
      line-height: 32px;
    }
    &.is-highlight .value-num {
      color: #F44F4F; /* 毛利率等需标红的指标数字 */
    }
    .value-unit {
      font-size: 12px;
      color: #333;
      font-weight: 400;
    }
    .indicator-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #edf1fb3b;
      backdrop-filter: blur(1px);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      // transition: opacity 0.2s ease;
    }
    .smart-analysis-btn {
      width: 64px;
      height: 24px;
      border: none;
      background-image: linear-gradient(270deg, #4A5FF3 0%, #4E86FF 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 12px;
      // &:hover {
      //   background: #F0F2FF;
      // }
    }
  }
}
@media screen and (max-width: 1440px) {
  .#{$class-prefix} {
    .indicator-item {
      .value-num {
        font-size: 18px;
      }
      .indicator-name {
        font-size: 11px;
      }
    }
  }
}
</style>

<style lang="scss">
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar {
  height: 0;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container:hover::-webkit-scrollbar {
  height: 6px;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar-track {
  background: #e8e8e8;
  border-radius: 3px;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border-radius: 3px;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar-thumb:hover {
  background: #909090;
}
</style>
